<section class="main-content">
  <h1>{{'title.deleted' | translate}}</h1>

  <mat-card class="unlocked-document-card no-padding">

    <p class="grey-label padding-section">
      {{'report.deletedDocuments.subtitle' | translate}}
    </p>

    <!-- No Tabs - Original View -->
    <section *ngIf="!showTabs">
      <div class="spinner-container" *ngIf="loading$ | async">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>

      <section [hidden]="loading$ | async">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

          <!-- deletionBatchId -->
          <ng-container matColumnDef="deletionBatchId">
            <mat-header-cell
              *matHeaderCellDef>{{'report.deletedDocuments.deletionBatchId' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
          </ng-container>

          <!-- executionDate -->
          <ng-container matColumnDef="executionDate">
            <mat-header-cell *matHeaderCellDef>{{'report.deletedDocuments.executionDate' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.executionTime | date:'medium'}} </mat-cell>
          </ng-container>

          <!-- view -->
          <ng-container matColumnDef="view">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <button mat-button mat-icon-button (click)="viewDetails(element.id)"
                      matTooltip="{{'report.deletedDocuments.detailsTooltip' | translate}}" class="table-button">
                <mat-icon svgIcon="view_data"></mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <!-- export -->
          <ng-container matColumnDef="export">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <button mat-button [disabled]="disableDomainJobButton()"
                      [matTooltip]="'report.deletedDocuments.details.missingDomainJobExportPermission' | translate"
                      [matTooltipDisabled]="!disableDomainJobButton()"
                      class="btn-background-blue fw-500" (click)="exportDeletedDocsForDomainJob(element.id)">
                {{'report.deletedDocuments.exportButtonLabel' | translate}}
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns();"></mat-row>
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">{{"dataNotFound" | translate}}</td>
          </tr>
        </table>
      </section>
      <section [hidden]="loading$ | async">
        <mat-paginator #standardPaginatorNoTabs [pageSize]="10" [pageSizeOptions]="[10, 20, 50]"
                       showFirstLastButtons></mat-paginator>
      </section>
    </section>

    <!-- With Tabs -->
    <section *ngIf="showTabs">
      <mat-tab-group>
        <!-- Standard Tab -->
        <mat-tab label="Standard">
          <ng-template matTabContent>
            <div class="tab-content">
              <div class="spinner-container" *ngIf="loading$ | async">
                <mat-spinner [diameter]="40"></mat-spinner>
              </div>

              <section [hidden]="loading$ | async">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                  <!-- deletionBatchId -->
                  <ng-container matColumnDef="deletionBatchId">
                    <mat-header-cell
                      *matHeaderCellDef>{{'report.deletedDocuments.deletionBatchId' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
                  </ng-container>

                  <!-- executionDate -->
                  <ng-container matColumnDef="executionDate">
                    <mat-header-cell
                      *matHeaderCellDef>{{'report.deletedDocuments.executionDate' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.executionTime | date:'medium'}} </mat-cell>
                  </ng-container>

                  <!-- view -->
                  <ng-container matColumnDef="view">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <button mat-button mat-icon-button (click)="viewDetails(element.id)"
                              matTooltip="{{'report.deletedDocuments.detailsTooltip' | translate}}"
                              class="table-button">
                        <mat-icon svgIcon="view_data"></mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>

                  <!-- export -->
                  <ng-container matColumnDef="export">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <button mat-button [disabled]="disableDomainJobButton()"
                              [matTooltip]="'report.deletedDocuments.details.missingDomainJobExportPermission' | translate"
                              [matTooltipDisabled]="!disableDomainJobButton()"
                              class="btn-background-blue fw-500"
                              (click)="exportDeletedDocsForDomainJob(element.id)">
                        {{'report.deletedDocuments.exportButtonLabel' | translate}}
                      </button>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns();"></mat-row>
                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">{{"dataNotFound" | translate}}</td>
                  </tr>
                </table>
              </section>
              <section [hidden]="loading$ | async">
                <mat-paginator #standardPaginatorWithTabs [pageSize]="10" [pageSizeOptions]="[10, 20, 50]"
                               showFirstLastButtons></mat-paginator>
              </section>
            </div>
          </ng-template>
        </mat-tab>

        <!-- FINRA Tab -->
        <mat-tab label="Compliance archive">
          <ng-template matTabContent>
            <div class="tab-content">
              <div class="spinner-container" *ngIf="loading$ | async">
                <mat-spinner [diameter]="40"></mat-spinner>
              </div>

              <section [hidden]="loading$ | async">
                <table mat-table [dataSource]="dataSourceFinra" class="mat-elevation-z8">

                  <!-- deletionBatchId -->
                  <ng-container matColumnDef="deletionBatchId">
                    <mat-header-cell
                      *matHeaderCellDef>{{'report.deletedDocuments.deletionBatchId' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
                  </ng-container>

                  <!-- executionDate -->
                  <ng-container matColumnDef="executionDate">
                    <mat-header-cell
                      *matHeaderCellDef>{{'report.deletedDocuments.executionDate' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.executionTime | date:'medium'}} </mat-cell>
                  </ng-container>

                  <!-- view -->
                  <ng-container matColumnDef="view">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <button mat-button mat-icon-button (click)="viewDetails(element.id)"
                              matTooltip="{{'report.deletedDocuments.detailsTooltip' | translate}}"
                              class="table-button">
                        <mat-icon svgIcon="view_data"></mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                  <!-- export -->
                  <ng-container matColumnDef="export">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <button mat-button class="btn-background-blue fw-500"
                              [disabled]="disableDomainJobButton()"
                              [matTooltip]="'report.deletedDocuments.details.missingDomainJobExportPermission' | translate"
                              [matTooltipDisabled]="!disableDomainJobButton()"
                              (click)="exportDeletedDocsForDomainJob(element.id)">
                        {{'report.deletedDocuments.exportButtonLabel' | translate}}
                      </button>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns();"></mat-row>
                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">{{"dataNotFound" | translate}}</td>
                  </tr>
                </table>
              </section>
              <section [hidden]="loading$ | async">
                <mat-paginator #finraPaginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50]"
                               showFirstLastButtons></mat-paginator>
              </section>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </section>
  </mat-card>
</section>
